import React from 'react';
import HandinLogo from '../../../../../../static/handin-logo.svg';
import TurnitinLogo from '../../../../../../static/turnitin.png';
import QuizzesLogo from '../../../../../../static/quizzes.png';
import { ExtensionOutlined } from '@mui/icons-material';
import { LTI1P3_PROVIDER } from '@core/assignments/constants';
import { getAssignmentProvider } from '@core/assignments/utils';
import { Assignment } from '@core/assignments/types';
import { LtiProvider } from '@ublend-npm/aula-schema';

const ToolLogos = {
  'hand-in': HandinLogo,
  handin: HandinLogo,
  turnitin: TurnitinLogo,
  quizzes: QuizzesLogo,
};

const ProviderConfig = {
  'hand-in': {
    title: 'Handin',
  },
  handin: {
    title: 'Handin',
  },
  turnitin: {
    title: 'Turnitin',
  },
  quizzes: {
    title: 'Quizzes',
  },
  'lti-1p3': {
    title: 'Lti-1p3',
  },
};

type Props = {
  assignment: Assignment;
  providers: Array<LtiProvider>;
};

const Logo = ({ assignment, providers }: Props) => {
  const [imageError, setImageError] = React.useState(false);

  if (!assignment.provider) {
    return <ExtensionOutlined />;
  }

  const isLti1P3Provider = assignment.provider === LTI1P3_PROVIDER;
  const providerItem = getAssignmentProvider(assignment, providers);
  const providerConfig = ProviderConfig[assignment.provider];

  if (!providerConfig) {
    return <ExtensionOutlined />;
  }

  const providerName = isLti1P3Provider
    ? providerItem?.description
    : providerConfig.title;

  const providerIconUrl = providerItem?.iconUrl;
  const src = ToolLogos[assignment.provider] ?? providerIconUrl;

  React.useEffect(() => {
    setImageError(false);
  }, [src]);

  if (!src || imageError) {
    return <ExtensionOutlined />;
  }

  return (
    <img
      width="24px"
      height="24px"
      src={src}
      alt="assignment"
      aria-label={`${providerName} icon`}
      onError={() => setImageError(true)}
    />
  );
};

export default Logo;
